import React from "react";
import { getImage } from "../../../../../utils/getImages";
import "./app.css";
const ImageGallary = ({ cardData, activetab }) => {
  return (
    <div style={{ margin: "10px" }}>
      <h1 className="title-color mb-4" style={{ textAlign: "center" }}>
        {activetab === "english"
          ? cardData?.title
          : activetab === "simplified_chinese"
          ? cardData?.simplified_chinese_title
          : activetab === "arabic"
          ? cardData?.arabic_title
          : activetab === "bahasa"
          ? cardData?.bahasa_title
          : cardData?.traditional_chinese_title}
      </h1>
      <div
        className="row"
        style={{
          display: "flex",
          justifyContent: "center",
          flexWrap: "wrap",
          width: "100%",
          gap: "10px",
        }}
      >
        {cardData?.dataArray?.map((item, index) => (
          <div
            className="col-3"
            key={index}
            style={{
              flex: "0 0 calc(33.33% - 10px)",
              maxWidth: "calc(33.33% - 10px)",
              boxSizing: "border-box",
            }}
          >
            <div>
              <img
                src={getImage(item?.image)}
                style={{
                  width: "100%",
                  borderRadius: "10px",
                  height: "300px",
                  objectFit: "cover",
                }}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ImageGallary;
